
import { computed, defineComponent } from 'vue';

import useApp from '@/composables';
import Details from '@/components/Details/Details.vue';
import ESARSite from '@/models/ESARSite';
import LegalLandDescription from '@/models/LegalLandDescription';

export default defineComponent({
    name: 'ListItem',
    components: { Details },
    props: {
        id: { type: String, required: true },
        item: {
            type: ESARSite,
            default: new ESARSite({
                id: '',
                operationName: '',
                documentsInFile: 0,
                coordinates: [],
                contaminants: [],
                LLD: [],
                riskManagementData: []
            })
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        isSkeleton: {
            type: Boolean,
            default: false,
        },
        showSiteStatus: {
            type: Boolean,
            default: true,
        },
    },
    setup(props) {
        const { state, setOpenSite, setHoveredSite, removeHoveredSite } = useApp();

        const ats = computed(() => props.item.LLD.find((i:LegalLandDescription) => i.ATS)?.ATS);
        const pbl = computed(() => props.item.LLD.find((i:LegalLandDescription) => i.PBL)?.PBL);
        const showReport = computed(() => props.isActive && props.item && props.item.currentSiteStatus);

        const onClick = function (event: MouseEvent) {
            const clickedElement = (event.target as HTMLElement);
            if (clickedElement.className.includes('mdi-text-box-multiple-outline')) {
                window.open(props.item.documentsURL);
            } else if (props.item.id) {
                setOpenSite(props.item);
            }
        };

        const onMouseEnter = () => {
            if (state.hoveredSite && state.hoveredSite.id === props.item.id) {
                return;
            }
            setHoveredSite(props.item);
        };

        const onMouseLeave = () => {
            removeHoveredSite();
        };

        return {
            ats,
            pbl,
            showReport,
            onClick,
            onMouseEnter,
            onMouseLeave
        };
    }
});
